import React from 'react';
import LazyLoad from 'react-lazyload';
import { useTranslation } from 'react-i18next';
import DateRangeIcon from '@material-ui/icons/DateRange';
import SettingsInputComponentIcon from '@material-ui/icons/SettingsInputComponent';

const Feature = () => {
   const { t } = useTranslation();

   return (
      <section id="feature" className="feature">
         <div className="feature-decor">
            <div className="feature-circle1"><img src="assets/images/feature2.png" alt="" /></div>
         </div>
         <div className="container">
            <div className="row">
               <div className="feature-phone">
                  <LazyLoad><img src={`assets/images/${t('imagePrefix')}laptop.png`} className="img-fluid" alt="laptop" /></LazyLoad>
               </div>
               <div className="offset-md-2 col-md-10 offset-lg-4 col-lg-7 offset-xl-6 col-xl-7">
                  <div className="row">
                     <div className="col-sm-12">
                        <h2 className="title pink-title text-center text-md-left">{t('best features of')} <span>{t('ourmind of')}</span></h2>
                     </div>
                  </div>
                  <div className="row">
                     <div className="col-12 col-md-6">
                        <ul className="feature-style">
                           <li>
                              <div className="feature-icon">
                                 {/*                                  <img src="assets/images/icon/1.png" alt="icon" /> */}

                                 <img src="assets/images/icon/ok-icon.svg" height="24" alt="icon" />
                              </div>
                              <div className="feature-subtitle">
                                 <h3>{t('easy to use')}</h3>
                              </div>
                              <div>
                                 <p>
                                    {t('if you know how to google, you will master ourmind')}
                                 </p>
                              </div>
                           </li>
                           <li>
                              <div className="feature-icon">
                                 <DateRangeIcon style={{ color: '#ff0d7f' }} className="mat-ui-icon medium" />
                              </div>
                              <div className="feature-subtitle">
                                 <h3>{t('up to date')}</h3>
                              </div>
                              <div>
                                 <p>{t('latest knowledge in one place')}</p>
                              </div>
                           </li>
                           <li>
                              <div className="feature-icon">
                                 <SettingsInputComponentIcon style={{ color: '#ff0d7f' }} className="mat-ui-icon medium" />
                              </div>
                              <div className="feature-subtitle">
                                 <h3>{t('integrability')}</h3>
                              </div>
                              <div>
                                 <p>{t('ourmind is possible to integrate with your existing systems')}*</p>
                                 <p>{t('for example')}:</p>

                                 <div className="mb-0 mt-3 text-center">
                                    <LazyLoad><img width="45%" src="assets/images/integrations/slack-logo.svg" alt="slack" /></LazyLoad>
                                 </div>
                                 <div className="mb-0 text-center">
                                    <LazyLoad><img width="50%" src="assets/images/integrations/salesforce-logo.png" alt="salesforce" /></LazyLoad>
                                 </div>
                                 <div className="mb-0 text-center">
                                    <LazyLoad><img width="50%" src="assets/images/integrations/pipedrive-logo.svg" alt="pipedrive" /></LazyLoad>
                                 </div>

                                 <p className="text-tiny mt-3"><cite>*{t('will be evaluated case by case')}</cite></p>
                              </div>
                           </li>
                        </ul>
                     </div>
                     <div className="col-12 col-md-6 sm-m-top">
                        <ul className="feature-style">
                           <li>
                              <div className="feature-icon">
                                 <img src="assets/images/icon/fast-icon.svg" height="24" alt="icon" />
                              </div>
                              <div className="feature-subtitle">
                                 <h3>{t('fast')}</h3>
                              </div>
                              <div>
                                 <p>{t('exact keywords and classification by topic')}</p>
                              </div>
                           </li>
                           <li>
                              <div className="feature-icon">
                                 <img src="assets/images/icon/bulb-icon.svg" height="24" alt="icon" />
                              </div>
                              <div className="feature-subtitle">
                                 <h3>{t('expert')}</h3>
                              </div>
                              <div>
                                 <p>{t('managing by knowledge has never been this easy')}</p>
                              </div>
                           </li>
                        </ul>
                     </div>
                  </div>

               </div>
            </div>
         </div>
      </section>
   )
}

export default Feature;


// WEBPACK FOOTER //
// ./src/components/feature.js